import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import {
  AppBar,
  Badge,
  Box,
  IconButton,
  Toolbar,
  Menu,
  Typography,
  Chip,
  Avatar,
  Button,
  Drawer,
} from '@mui/material';
import PropTypes from 'prop-types';
// Dropdown Component
import CartDropdown from './CartDropdown';
import MessageDropdown from './MessageDropdown';
import NotificationDropdown from './NotificationDropdown';
import ProfileDropdown from './ProfileDropdown';
import CustomTextField from '../../../components/forms/custom-elements/CustomTextField';
import userimg from '../../../assets/header-img.webp';
import firebase from '../../../firebase';
import { useDispatch, useSelector } from 'react-redux';
import { updateProfile, updateRole } from '../../../redux/profile/action';
import EditNotificationsOutlinedIcon from '@mui/icons-material/EditNotificationsOutlined';
import {
  getAllRequestNumber,
  getRequestNumberForDistrictCTU,
  getRequestNumberForOwnedCTU,
  getRequestNumberForUlbCTU,
} from '../../../firebase/functions';

const Header = ({ sx, customClass, toggleSidebar, toggleMobileSidebar }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const profile = useSelector((state) => state.ProfileReducer);
  const role = useSelector((state) => state.RoleReducer);

  const [joinAdoptCount, setJoinAdoptCount] = useState(0);

  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  // 2
  const [anchorEl2, setAnchorEl2] = React.useState(null);

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  // 4
  const [anchorEl4, setAnchorEl4] = React.useState(null);

  const handleClick4 = (event) => {
    setAnchorEl4(event.currentTarget);
  };

  const handleClose4 = () => {
    setAnchorEl4(null);
  };

  // drawer
  const [showDrawer, setShowDrawer] = useState(false);

  const handleDrawerClose = () => {
    setShowDrawer(false);
  };

  // drawer top
  const [showDrawer2, setShowDrawer2] = useState(false);

  const handleDrawerClose2 = () => {
    setShowDrawer2(false);
  };

  const getJoinAdoptRequestNumber = async () => {
    const userEmail = profile?.info?.user_record?.user_name;
    const roleId = role?.info?.role_id;
    if (roleId === 1) {
      const res = await getAllRequestNumber()
      setJoinAdoptCount(res)
    } else {
      let res1;
      let res2;
      res1 = await getRequestNumberForOwnedCTU(userEmail);
      if (roleId === 7) {
        const ulbCode = profile?.info?.user_details[0]?.ulb_code;
        res2 = await getRequestNumberForUlbCTU(ulbCode);
      } else if (roleId === 6) {
        const districtCode = profile?.info?.user_details[0]?.district_code;
        res2 = await getRequestNumberForDistrictCTU(districtCode);
      }
      setJoinAdoptCount(res1 + res2);
    }
  };

  useEffect(() => {
    if (profile?.info?.user_record?.user_name) {
      getJoinAdoptRequestNumber();
    }
  }, [profile, role]);

  return (
    <AppBar sx={sx} elevation={0} className={customClass}>
      <Toolbar style={{ minHeight: '90px', zIndex: 999999 }}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleSidebar}
          size="large"
          sx={{
            display: {
              lg: 'flex',
              xs: 'none',
            },
          }}
        >
          <FeatherIcon icon="menu" />
        </IconButton>

        <IconButton
          size="large"
          color="inherit"
          aria-label="menu"
          onClick={toggleMobileSidebar}
          sx={{
            display: {
              lg: 'none',
              xs: 'flex',
            },
          }}
        >
          <FeatherIcon icon="menu" width="20" height="20" />
        </IconButton>

        <Box flexGrow={1} />
        {joinAdoptCount > 0 && (
          <Button onClick={() => navigate('/approve-partner')}>
            <Box display="flex" alignItems="center">
              <IconButton>
                <EditNotificationsOutlinedIcon sx={{ color: 'red' }} />
              </IconButton>
              <Box
                sx={{
                  display: {
                    xs: 'none',
                    sm: 'flex',
                  },
                  alignItems: 'center',
                }}
              >
                <Typography color="red" variant="h3" fontWeight="700" sx={{ ml: 1 }}>
                  {joinAdoptCount}
                </Typography>
                <Typography
                  variant="h3"
                  fontWeight="700"
                  color="red"
                  sx={{
                    ml: 1,
                  }}
                >
                  Partner Join/Adopt Requests Pending
                </Typography>
              </Box>
            </Box>
          </Button>
        )}
        <Button
          aria-label="menu"
          color="inherit"
          aria-controls="profile-menu"
          aria-haspopup="true"
          onClick={handleClick4}
        >
          <Box display="flex" alignItems="center">
            <Avatar
              src={userimg}
              alt={userimg}
              sx={{
                width: '30px',
                height: '30px',
              }}
            />
            <Box
              sx={{
                display: {
                  xs: 'none',
                  sm: 'flex',
                },
                alignItems: 'center',
              }}
            >
              <Typography color="textSecondary" variant="h5" fontWeight="400" sx={{ ml: 1 }}>
                Hi,
              </Typography>
              <Typography
                variant="h5"
                fontWeight="700"
                sx={{
                  ml: 1,
                }}
              >
                {profile?.info?.user_record?.name}
              </Typography>
              <FeatherIcon icon="chevron-down" width="20" height="20" />
            </Box>
          </Box>
        </Button>
        <Menu
          id="profile-menu"
          anchorEl={anchorEl4}
          keepMounted
          open={Boolean(anchorEl4)}
          onClose={handleClose4}
          sx={{
            '& .MuiMenu-paper': {
              width: '385px',
              right: 0,
              top: '70px !important',
            },
            '& .MuiList-padding': {
              p: '30px',
            },
          }}
        >
          <Typography color="textSecondary" variant="h5" fontWeight="400" sx={{ mb: 3 }}>
            User Role - {profile?.info?.user_record?.user_role}
          </Typography>
          <Link
            style={{
              textDecoration: 'none',
            }}
            to="/auth/login"
          >
            <Button
              sx={{
                mr: 2,
                display: 'block',
                width: '100%',
              }}
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch(updateRole({ info: {} }));
                dispatch(updateProfile({ logged_in: false, info: {}, token: '' }));
                firebase.auth().signOut();
              }}
            >
              Logout
            </Button>
          </Link>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  sx: PropTypes.object,
  customClass: PropTypes.string,
  toggleSidebar: PropTypes.func,
  toggleMobileSidebar: PropTypes.func,
};

export default Header;
